import { breakpoint, colors, fontSize, fontWeight, mediaQueryHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  overlay: css({
    position: 'fixed',
    top: 62, // offset navigation height
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 600, // zIndex is set high to avoid conflicts with pinata components
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    perspective: '600px',
    overflowY: 'auto',
  }),

  fader: css({
    backgroundColor: 'rgba(19, 31, 74, 0.5)',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 0,
  }),

  wrapper: css({
    position: 'relative',
    display: 'flex',
    background: 'white',
    justifyContent: 'start',
    alignContent: 'center',
    flexDirection: 'column-reverse',
    maxWidth: '100%',
    borderRadius: 0,
    width: '100%',
    minHeight: '100%',
    top: 0,
    overflowY: 'auto',
    [mediaQueryHelper(breakpoint.phone)]: {
      position: 'relative',
      minHeight: 'auto',
      height: 'auto',
      maxWidth: '528px',
      borderRadius: 5,
      justifyContent: 'center',
    },
    [mediaQueryHelper(breakpoint.tablet)]: {
      flexDirection: 'row',
      maxWidth: '820px',
    },
    '& > div': {
      width: 'auto',
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 24px 24px',
      borderRadius: 'inherit',
      flexGrow: 0,

      '&:first-child': {
        background: '#FFFFFF',
      },

      [mediaQueryHelper(breakpoint.phone)]: {
        padding: '43px 36px !important',
      },

      [mediaQueryHelper(breakpoint.desktop)]: {
        width: '440px',
        padding: '43px 36px !important',
      },
    },
  }),

  leftDiv: css({
    height: '50%',
    justifyContent: 'center',
    [mediaQueryHelper(breakpoint.mobile)]: {
      height: 'auto',
      justifyContent: 'inherit',
    },
  }),

  rightDiv: css({
    height: '50%',
    justifyContent: 'center',
    [mediaQueryHelper(breakpoint.mobile)]: {
      height: 'auto',
      justifyContent: 'inherit',
    },
  }),

  mobileShow: css({
    display: 'block',
    marginTop: 0,
    fontSize: 20,
    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'none',
      marginTop: 12,
      fontSize: 22,
    },
  }),

  desktopShow: css({
    display: 'none',
    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'block',
    },
  }),

  heading: css({
    marginBottom: 24,
    fontSize: 24,
    fontWeight: fontWeight.semiBold,
    color: colors.blackPearl,
    width: '100%',
    marginTop: 12,
  }),

  centeredHeading: css({
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'auto',
  }),

  mobileHeader: css({
    margin: '16px 0',
  }),

  lineItem: css({
    margin: 0,
    fontSize: fontSize.default,
    lineHeight: '140%',
    marginBottom: spacing.large,
    display: 'flex',
    p: {
      margin: 0,
      color: colors.scorpion,
      strong: {
        color: colors.blackPearl,
      },
    },
  }),

  extraLineItem: css({
    margin: 0,
    fontSize: fontSize.default,
    lineHeight: '140%',
    marginBottom: spacing.large,
    display: 'flex',
    p: {
      margin: 0,
      color: colors.blackPearl,
      fontWeight: fontWeight.semiBold,
      span: {
        color: colors.cornflowerBlue,
      },
    },
  }),

  check: css({
    width: '20px',
    height: '20px',
    margin: '0 10px 0 0',
    display: 'inline-block',
    verticalAlign: 'top',
  }),

  formWrapper: css({
    marginBottom: spacing.small,
    marginTop: spacing.default,
  }),

  centerText: css({
    textAlign: 'center',
  }),

  closeButton: css({
    position: 'absolute',
    top: spacing.large,
    right: spacing.large,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    padding: 8,
    cursor: 'pointer',
    border: '1px solid rgba(136, 139, 142, 0.5)',
    borderRadius: 3,
    lineHeight: 0,

    '&:hover, &:focus': {
      border: '1px solid rgba(136, 139, 142, 0.7)',
    },

    [mediaQueryHelper(breakpoint.phone)]: {
      padding: 6,
    },
  }),

  ctaContainer: css({
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
  }),

  ctaButton: css({
    display: 'flex',
    alignItems: 'center',
    minWidth: 160,
    borderRadius: 4,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '16px',
    padding: '0 15px',
    textDecoration: 'none',
    justifyContent: 'center',
    transition: 'all .3s ease-in-out',
  }),

  signupButton: css({
    backgroundColor: '#5EA5EE',
    marginBottom: 16,
    height: 45,
    color: '#FFFFFF',

    '&:hover, &:focus': {
      backgroundColor: '#2E71C1',
      boxShadow: '0px 4px 4px rgba(19, 34, 84, 0.15)',
    },
  }),

  bookDemoButton: css({
    backgroundColor: '#FFFFFF',
    border: '1px solid #5EA5EE',
    maxHeight: 43,
    height: 43,
    color: '#5EA5EE',

    '&:hover, &:focus': {
      backgroundColor: ' #5EA5EE',
      color: '#FFFFFF',
    },
  }),

  loginFooterText: css({
    display: 'flex',
    flexDirection: 'row',
    color: colors.scorpion,
    fontSize: fontSize.default,
    lineHeight: '19px',
    fontWeight: fontWeight.regular,
    margin: 'auto',
    marginTop: 16,
    whiteSpace: 'nowrap',

    a: {
      color: colors.cornflowerBlue,
      marginLeft: 2,
      cursor: 'pointer',
      textDecoration: 'none',
    },
  }),
}

export default styles
